import { Alert } from '@restworld/ui-ds-base';
import { CardWrapper } from './card-wrapper';
import { TrainingSectionItem } from './training-section-item';
import { StyledSeparator } from './worker-experiences-section';
import { useAtomValue } from 'jotai';
import { workerTrainingsAtom } from '../global-state.worker-data';
import { useProfileCommonIntl } from './hooks';

export const TrainingSection = () => {
  const workerTrainings = useAtomValue(workerTrainingsAtom);
  const itemsCount = workerTrainings?.length || 0;
  const { missingInfoText, translate: t } = useProfileCommonIntl();
  const { isWorkerTrainingInfoMissing } = useIsWorkerTrainingInfoMissing();

  return (
    <CardWrapper variant="add" title={t('common:training')} editPageType="education">
      <div className="flex flex-col items-start pt-4">
        {isWorkerTrainingInfoMissing && <Alert text={missingInfoText} className="mb-4" />}
        {workerTrainings?.map((workerTraining, index) => (
          <div className="w-full" key={index} id={`education-${index}`}>
            <TrainingSectionItem key={index} {...{ workerTrainingIndex: index, workerTraining }} />
            {index < itemsCount - 1 && <StyledSeparator />}
          </div>
        ))}
      </div>
    </CardWrapper>
  );
};

export function useIsWorkerTrainingInfoMissing() {
  const workerTrainings = useAtomValue(workerTrainingsAtom);
  const isWorkerTrainingInfoMissing = !workerTrainings || workerTrainings?.length === 0;

  return { isWorkerTrainingInfoMissing };
}
